import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  CustomSoftIcon,
  SoftwareProIcon,
  SoftwareMainIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        Modernize your business potential with our modern{" "}
        <Link
          to="/android-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Android app development services
        </Link>{" "}
        . Our team specializes in crafting personalized user experiences with
        unique interfaces, helping you stand out in a competitive market. With a
        focus on incorporating the latest features, our skilled developers
        ensure your business stays ahead of the curve. Whether you seek a native
        or hybrid app, we're here to provide firm support every step of the way.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description: (
      <>
        Our{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iOS app development services
        </Link>{" "}
        enable businesses to swiftly produce high-performance native iOS apps by
        utilizing advanced iOS development tools and languages like Swift,
        Objective C, XCode, and others. Whether you need simple
        consumer-business iOS applications or complex on-demand apps, our iOS
        app development services in Los Angeles are designed to get you started
        as an app entrepreneur. We can turn your idea into a feature-rich mobile
        application.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        Launch a player-centric game and pave the way for tech-driven revenue by
        entering the market with advertisements, premium subscriptions, and
        featured content. We’re an award-winning{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game app development company
        </Link>{" "}
        experts in crafting a highly advanced gaming experience powered by
        blockchain, NFTs, AR, and VR. Additionally, we possess extensive
        expertise in developing comprehensive games on a large scale, utilizing
        both 2D and 3D technology.
      </>
    ),
  },
  {
    icon: CustomSoftIcon,
    title: "Custom Software Development",
    description: (
      <>
        As a software development services company Los Angeles, we offer
        customized solutions to businesses according to the requirements of
        their organizational structure and target audience. Our{" "}
        <Link
          to="/custom-software-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          custom software development services
        </Link>{" "}
        are based on the ideation, design, and implementation of software apps,
        and every aspect is aligned with the customer’s requirements. TekRevol’s
        qualified software developers in Los Angeles build B2B and B2C
        enterprise-scale solutions that can help your business grow. You can
        improve the overall productivity of your operations by taking the
        maximum benefit of these custom software solutions.
      </>
    ),
  },
  {
    icon: SoftwareProIcon,
    title: "Software Product Development",
    description:
      "Our software product development service is designed to bring your vision to life with precision and innovation. From design to implementation, our team works directly with you to understand your needs and objectives. Whether you need a custom solution or an improvement to an existing product, we provide end-to-end support, guiding you through every stage of the development process. By utilizing the latest technologies and industry best practices, we precisely design, develop, and test your software product to ensure its functionality.",
  },
  {
    icon: SoftwareMainIcon,
    title: "Software Support and Maintenance",
    description:
      "As the best Los Angeles Software Development Company, we offer software support and maintenance services to ensure the consistent and reliable operation of software applications. These services encompass activities ranging from performance improvements to security updates and feature upgrades. Whether it involves routine updates to stay in sync with advancing technology or responsive technical support when needed, these services are significant for maintaining flawless performance.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Our Custom App and Software Development Services in Los Angeles
            </h2>
            <p className="impro_para">
              We go beyond the traditional role of a software development
              company Los Angeles and position ourselves as your innovation
              partner. Our highly skilled team excels at transforming your
              unique vision into a reality. Through a precise blend of
              creativity and technical expertise, we design bespoke iOS and
              Android apps that capture the spirit of your business while also
              providing flawless functionality.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
